export default __webpack_public_path__ + "static/media/evaluation-icon.47008b46.svg";